import { createBrowserRouter, type RouteObject } from "react-router";
import { AboutPage } from "@/src/about/pages/about-page";
import { CareersPage } from "@/src/careers/pages/careers-page";
import { SITE_ROUTES } from "@/src/common/constants/site-routes";
import { SiteLayout } from "@/src/common/layouts/site-layout";
import { NotFoundPage } from "@/src/common/pages/not-found-page";
import { ContactPage } from "@/src/contact/pages/contact-page";
import { FeaturesPage } from "@/src/features/pages/features-page";
import { HomePage } from "@/src/home/pages/home-page";
import { LegalNoticesPage } from "@/src/legal/pages/legal-notices-page";
import { PrivacyPage } from "@/src/legal/pages/privacy-page";
import { TermsPage } from "@/src/legal/pages/terms-page";
import { PricingPage } from "@/src/pricing/pages/pricing-page";

export const siteRoutes: RouteObject[] = [
	{
		element: <SiteLayout />,
		children: [
			{ path: SITE_ROUTES.HOME, element: <HomePage /> },
			{ path: SITE_ROUTES.FEATURES, element: <FeaturesPage /> },
			{ path: SITE_ROUTES.PRICING, element: <PricingPage /> },
			{ path: SITE_ROUTES.ABOUT, element: <AboutPage /> },
			{ path: SITE_ROUTES.CONTACT, element: <ContactPage /> },
			{ path: SITE_ROUTES.CAREERS, element: <CareersPage /> },
			{ path: SITE_ROUTES.PRIVACY, element: <PrivacyPage /> },
			{ path: SITE_ROUTES.TERMS, element: <TermsPage /> },
			{ path: SITE_ROUTES.LEGAL_NOTICES, element: <LegalNoticesPage /> },
			{ path: "*", element: <NotFoundPage /> },
		],
	},
];

export const createSiteRouter = () => createBrowserRouter(siteRoutes);
